module.exports = __webpack_public_path__ + "assets/images/1qATGy18ji.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/Bdd/pages/gznyzyxy/print/image/app3.png
// module id = 2195
// module chunks = 0